import React from 'react';

export default function NotificationItem(props) {
  return (
    <div className={'vm-leadform-notification-item'}>
      <p style={{margin: 0}}>{props.message}</p>
    </div>
  );
}


